/** Configuration File
 **/

module.exports = {
    backend: 'https://taxonomy-api-prod.dc1.mwancloud.com/'
}
